<template>
    <div class="page noselect">
        <!--        <div class="absBack">-->
        <!--            <div onclick="window.history.back()">-->
        <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
        <!--            </div>-->
        <!--        </div>-->

        <v-container grid-list-md>
            <h2 class="myTitle">Seite nicht gefunden</h2>

            <div class="spacer-25"></div>
            <div class="spacer-25 text-center">
                <v-btn color="btn-df okBtn" rounded @click.native.passive="$ebus.$emit('gotoStart')">
                    Zur Startseite
                </v-btn>
            </div>
            <div class="spacer-25"></div>

        </v-container>
    </div>
</template>

<script>
    export default {
        // methods:{
        //     gotoStart(){
        //         this.$router.push({name: 'Home'});
        //     }
        // }
    }
</script>

<style scoped lang="scss">

</style>